export const html   = 'http://www.w3.org/1999/xhtml';
export const mathml = 'http://www.w3.org/1998/Math/MathML';
export const svg    = 'http://www.w3.org/2000/svg';
export const xlink  = 'http://www.w3.org/1999/xlink';
export const xml    = 'http://www.w3.org/XML/1998/namespace';
export const xmlns  = 'http://www.w3.org/2000/xmlns';

export default { html, mathml, svg, xlink, xml, xmlns };
